'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FavoriteWindow = undefined;

var _RenameWindow = require('./RenameWindow.js');

var _SharingWindow = require('./SharingWindow.js');

var _GridHeaders = require('./GridHeaders.js');

var _FavoriteTextCmp = require('./FavoriteTextCmp');

var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);

var _FavoriteStyle = require('./FavoriteStyle');

var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoriteWindow = exports.FavoriteWindow = undefined;

exports.FavoriteWindow = FavoriteWindow = function FavoriteWindow(c, action) {
    var appManager = c.appManager,
        instanceManager = c.instanceManager,
        uiManager = c.uiManager,
        i18n = c.i18nManager.get(),
        uiConfig = c.uiConfig,
        apiPath = appManager.getApiPath(),
        apiResource = instanceManager.apiResource,
        apiEndpoint = instanceManager.apiEndpoint;

    var getDirection,
        getStoreUrl,
        favoriteStore,
        filtersStore,
        getFilterUrlParam,
        NameWindow,
        nameWindow,
        nameTextfield,
        createButton,
        updateButton,
        cancelButton,
        textfieldKeyUpHandlers,
        showFavoritesLink,
        showFavoritesLinkCt,
        searchTextfield,
        filtersComboBox,
        descriptionPanel,
        saveButtonHandler,
        saveButton,
        prevButton,
        nextButton,
        info,
        gridHeaders,
        renderers,
        windowBbarSeparator,
        windowBbar,
        grid,
        titles,
        windowItems,
        favoriteWindow,
        nameColWidth = _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.createdColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.buttonColWidth - _FavoriteStyle2.default.paddingColWidth - 2,
        storeFields = 'id,name,created,lastUpdated,access,title,description,user',
        urlFields = 'id,displayName~rename(name),created,lastUpdated,access,title,description,user',
        sortField = 'name',
        sortDirection = 'asc',
        cmpToToggle = [],
        layout = instanceManager.getStateCurrent() || {};

    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
        nameTextField = _getFavoriteTextCmp.nameTextField,
        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;

    getDirection = function getDirection(keepDir) {
        return sortDirection = keepDir ? sortDirection : sortDirection === 'asc' ? 'desc' : 'asc';
    };

    getStoreUrl = function getStoreUrl(field, keepDir) {
        sortField = field || sortField;

        var value = action === 'open' ? searchTextfield.getValue() : null;

        var url = apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + (value ? '&filter=displayName:ilike:' + value : '') + '&order=' + sortField + ':' + getDirection(keepDir);

        var filterParam = getFilterUrlParam(filtersComboBox.value);

        if (filterParam) {
            url += '&filter=' + filterParam;
        }

        return url;
    };

    favoriteStore = Ext.create('Ext.data.Store', {
        fields: storeFields.split(','),
        proxy: {
            type: 'ajax',
            reader: {
                type: 'json',
                root: apiEndpoint
            },
            startParam: false,
            limitParam: false
        },
        isLoaded: false,
        pageSize: 10,
        page: 1,
        defaultUrl: apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + '&order=name:asc',
        loadStore: function loadStore(url) {
            this.proxy.url = encodeURI(url || this.defaultUrl);

            this.load({
                params: {
                    pageSize: this.pageSize,
                    page: this.page
                }
            });
        },
        loadFn: function loadFn(fn) {
            if (this.isLoaded) {
                fn.call();
            } else {
                this.load(fn);
            }
        },
        get: function get(field, value) {
            var index = this.findExact(field, value);
            return index === -1 ? null : this.getAt(index);
        },
        listeners: {
            load: function load(store, records) {
                if (!this.isLoaded) {
                    this.isLoaded = true;
                }

                // pager
                var pager = store.proxy.reader.jsonData.pager;

                info.setText('Page ' + pager.page + ' of ' + pager.pageCount);

                prevButton.enable();
                nextButton.enable();

                if (pager.page === 1) {
                    prevButton.disable();
                }

                if (pager.page === pager.pageCount) {
                    nextButton.disable();
                }
            }
        }
    });

    filtersStore = Ext.create('Ext.data.Store', {
        fields: ['id', 'name'],
        data: [{ id: 'SHOW_ALL', name: i18n.show_all }, { id: 'CREATED_BY_ME', name: i18n.created_by_me }, { id: 'CREATED_BY_OTHERS', name: i18n.created_by_others }]
    });

    getFilterUrlParam = function getFilterUrlParam(filterId) {
        switch (filterId) {
            case 'SHOW_ALL':
                return null;
            case 'CREATED_BY_ME':
                return 'user.id:eq:' + appManager.userAccount.id;
            case 'CREATED_BY_OTHERS':
                return 'user.id:neq:' + appManager.userAccount.id;
            default:
                return null;
        }
    };

    textfieldKeyUpHandlers = {
        search: function search(cmp, e) {
            var t = cmp,
                value = Ext.isString(value) ? value : t.getValue();

            if (action === 'open' && e.keyCode === 13 && favoriteStore.getRange().length) {
                favoriteWindow.destroy();
                instanceManager.getById(favoriteStore.getAt(0).data.id);
            }

            if (value !== t.currentValue) {
                t.currentValue = value;

                favoriteStore.page = 1;
                favoriteStore.loadStore(getStoreUrl(null, true));
            }
        }
    };

    showFavoritesLink = Ext.create('Ext.form.Label', {
        text: i18n.show_favorites,
        style: 'color:#226aba',
        nextAction: 'hide',
        textMap: {
            hide: i18n.hide_favorites,
            show: i18n.show_favorites
        },
        toggle: function toggle() {
            var t = this;

            cmpToToggle.forEach(function (cmp) {
                cmp[t.nextAction]();
            });

            this.nextAction = this.nextAction === 'hide' ? 'show' : 'hide';

            this.setText(this.textMap[this.nextAction]);
        },
        listeners: {
            render: function render(cmp) {
                var t = this,
                    el = this.getEl();

                el.setStyle('cursor', 'pointer');

                el.on('click', function () {
                    t.toggle();
                });
            }
        }
    });

    showFavoritesLinkCt = Ext.create('Ext.container.Container', {
        width: _FavoriteStyle2.default.windowCmpWidth,
        style: 'text-align:right; padding-right:7px; padding-bottom:4px',
        items: showFavoritesLink
    });

    searchTextfield = Ext.create('Ext.form.field.Text', {
        width: _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.filtersComboBoxWidth,
        height: 27,
        style: 'margin-bottom: 1px; display: inline-block',
        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['color: #333']).join(';'),
        emptyText: i18n.search_for_favorites + '..',
        enableKeyEvents: true,
        currentValue: '',
        listeners: {
            keyup: {
                fn: function fn(cmp, e) {
                    textfieldKeyUpHandlers['search'](cmp, e);
                },
                buffer: 100
            }
        }
    });
    cmpToToggle.push(searchTextfield);

    filtersComboBox = Ext.create('Ext.form.field.ComboBox', {
        width: _FavoriteStyle2.default.filtersComboBoxWidth,
        height: 27,
        style: 'display: inline-block; top: 7px; right: 5px',
        fieldLabel: 'Filter',
        labelWidth: 30,
        store: filtersStore,
        displayField: 'name',
        valueField: 'id',
        value: 'SHOW_ALL',
        editable: false,
        listeners: {
            select: function select(_ref) {
                var value = _ref.value;

                var url = getStoreUrl(null, true, [getFilterUrlParam(value)]),
                    store = favoriteStore;

                store.page = store.page <= 1 ? 1 : store.page - 1;
                store.loadStore(url);
            }
        }
    });
    cmpToToggle.push(filtersComboBox);

    saveButton = Ext.create('Ext.button.Button', {
        text: i18n.save,
        // DHIS2-1147: avoid server conflict error when name value is not set
        disabled: true,
        xable: function xable() {
            this.setDisabled(!nameTextField.getValue());
        },
        handler: function handler() {
            saveButtonHandler();
        }
    });

    saveButtonHandler = function saveButtonHandler() {
        var name = nameTextField.getValue();

        // DHIS2-1147: avoid submitting when no name is available
        if (!name) {
            return;
        }

        var currentLayout = instanceManager.getStateCurrent(),
            id = instanceManager.getStateFavoriteId(),
            description = descriptionTextField.getValue();

        var preXhr = function preXhr() {
            favoriteWindow.destroy();
        };

        var fn = function fn(id, success, r) {
            currentLayout.id = id || currentLayout.id;
            instanceManager.getById(currentLayout.id, function (layout, isFavorite) {
                instanceManager.getReport(layout, isFavorite, false, false, function () {
                    uiManager.unmask();
                });
            });
        };

        currentLayout.apply({
            id: id,
            name: name,
            description: description
        }, ['id', 'name', 'description']);

        // search for a favorite with the same name
        // and ask confirmation for replacing it
        var request = new c.api.Request(c, {
            baseUrl: apiPath + '/' + apiEndpoint + '.json?fields=id&filter=displayName:eq:' + name,
            type: 'ajax',
            method: 'GET',
            success: function success(obj, _success, r) {
                if (obj && obj.pager.total > 0 && obj[apiEndpoint].length) {
                    uiManager.confirmReplace(i18n.save_favorite, function () {
                        preXhr();
                        currentLayout.clone().put(obj[apiEndpoint][0].id, fn, true, true);
                    });
                } else {
                    preXhr();
                    currentLayout.clone().post(fn, true, true);
                }
            }
        });

        request.run();
    };

    prevButton = Ext.create('Ext.button.Button', {
        text: i18n.prev,
        handler: function handler() {
            var url = getStoreUrl(null, true),
                store = favoriteStore;

            store.page = store.page <= 1 ? 1 : store.page - 1;
            store.loadStore(url);
        }
    });
    cmpToToggle.push(prevButton);

    nextButton = Ext.create('Ext.button.Button', {
        text: i18n.next,
        handler: function handler() {
            var url = getStoreUrl(null, true),
                store = favoriteStore;

            store.page = store.page + 1;
            store.loadStore(url);
        }
    });
    cmpToToggle.push(nextButton);

    info = Ext.create('Ext.form.Label', {
        cls: 'ns-label-info',
        width: 300,
        height: 22
    });
    cmpToToggle.push(info);

    gridHeaders = (0, _GridHeaders.GridHeaders)({
        width: _FavoriteStyle2.default.windowCmpWidth,
        height: 21,
        direction: 'asc',
        getDirection: function getDirection() {},
        items: [{
            text: i18n.name,
            textAlign: 'left',
            width: nameColWidth,
            height: 20,
            handler: function handler() {
                var url = getStoreUrl('name'),
                    store = favoriteStore;

                store.page = 1;
                store.loadStore(url);
            }
        }, {
            text: i18n.created,
            textAlign: 'left',
            width: _FavoriteStyle2.default.createdColWidth,
            height: 20,
            direction: 'asc',
            handler: function handler() {
                var url = getStoreUrl('created'),
                    store = favoriteStore;

                store.page = 1;
                store.loadStore(url);
            }
        }, {
            text: i18n.last_updated,
            textAlign: 'left',
            width: _FavoriteStyle2.default.lastUpdatedColWidth,
            height: 20,
            direction: 'asc',
            handler: function handler() {
                var url = getStoreUrl('lastUpdated'),
                    store = favoriteStore;

                store.page = 1;
                store.loadStore(url);
            }
        }]
    });
    cmpToToggle.push(gridHeaders);

    renderers = {
        open: function open(value, metaData, record) {
            var fn = function fn() {
                var element = Ext.get(record.data.id);

                if (element) {
                    element = element.parent('td');
                    element.addClsOnOver('link');
                    element.load = function () {
                        favoriteWindow.destroy();
                        instanceManager.getById(record.data.id);
                    };
                    element.handler = function () {
                        if (instanceManager.isStateUnsaved()) {
                            uiManager.confirmUnsaved(i18n.open, function () {
                                element.load();
                            });
                        } else {
                            element.load();
                        }
                    };
                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
                }
            };

            Ext.defer(fn, 100);

            return '<div id="' + record.data.id + '">' + value + '</div>';
        },
        saveas: function saveas(value, metaData, record) {
            var fn = function fn() {
                var element = Ext.get(record.data.id);

                if (element) {
                    element = element.parent('td');
                    element.handler = function () {
                        nameTextField.setValue(record.data.name);
                        descriptionTextField.setValue(record.data.description);
                    };
                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
                }
            };

            Ext.defer(fn, 100);

            return '<div id="' + record.data.id + '">' + value + '</div>';
        }
    };

    windowBbarSeparator = Ext.create('Ext.toolbar.Separator', {
        height: 20,
        style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
    });
    cmpToToggle.push(windowBbarSeparator);

    windowBbar = function () {
        var items = [];

        items.push(info, '->', prevButton, nextButton);

        if (action === 'saveas') {
            items.push(' ', windowBbarSeparator, ' ', saveButton);
        }

        return items;
    }();

    grid = Ext.create('Ext.grid.Panel', {
        cls: 'ns-grid',
        scroll: false,
        hideHeaders: true,
        columns: [{
            dataIndex: 'name',
            sortable: true,
            width: nameColWidth,
            renderer: renderers[action]
        }, {
            dataIndex: 'created',
            sortable: true,
            width: _FavoriteStyle2.default.createdColWidth,
            renderer: function renderer(value) {
                return (value || '').substring(0, 16).split('T').join(', ');
            }
        }, {
            dataIndex: 'lastUpdated',
            sortable: true,
            width: _FavoriteStyle2.default.lastUpdatedColWidth,
            renderer: function renderer(value) {
                return (value || '').substring(0, 16).split('T').join(', ');
            }
        }, {
            xtype: 'actioncolumn',
            sortable: false,
            width: _FavoriteStyle2.default.buttonColWidth,
            items: [{
                iconCls: 'ns-grid-row-icon-edit',
                getClass: function getClass(value, metaData, record) {
                    return 'tooltip-favorite-edit' + (!record.data.access.update ? ' disabled' : '');
                },
                handler: function handler(grid, rowIndex, colIndex, col, event) {
                    var record = this.up('grid').store.getAt(rowIndex),
                        x = event.target.x - nameColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.borderWidth + 6,
                        y = event.target.y - 34,
                        layoutObj = {
                        id: record.data.id,
                        name: record.data.name,
                        description: record.data.description
                    },
                        listeners = {},
                        fn;

                    if (record.data.access.update) {
                        fn = function fn() {
                            favoriteStore.loadStore(getStoreUrl(null, true));
                        };

                        listeners.show = function () {
                            favoriteWindow.destroyOnBlur = false;
                        };

                        listeners.destroy = function () {
                            favoriteWindow.destroyOnBlur = true;
                        };

                        nameWindow = (0, _RenameWindow.RenameWindow)(c, layoutObj, fn, listeners);
                        nameWindow.showAt(x, y);
                    }
                }
            }, {
                iconCls: 'ns-grid-row-icon-sharing',
                getClass: function getClass(value, metaData, record) {
                    return 'tooltip-favorite-sharing' + (!record.data.access.manage ? ' disabled' : '');
                },
                handler: function handler(grid, rowIndex) {
                    var record = this.up('grid').store.getAt(rowIndex);

                    if (record.data.access.manage) {
                        instanceManager.getSharingById(record.data.id, function (r) {
                            (0, _SharingWindow.SharingWindow)(c, r).show();
                        });
                    }
                }
            }, {
                iconCls: 'ns-grid-row-icon-delete',
                getClass: function getClass(value, metaData, record) {
                    return 'tooltip-favorite-delete' + (!record.data.access['delete'] ? ' disabled' : '');
                },
                handler: function handler(grid, rowIndex, colIndex, col, event) {
                    var record = this.up('grid').store.getAt(rowIndex),
                        id = record.data.id,
                        message;

                    if (record.data.access['delete']) {
                        uiManager.confirmDelete(i18n.delete_favorite, function () {
                            instanceManager.delById(id, function () {
                                // DHIS2-1475: preserve the filter when reloading the favorite list
                                favoriteStore.loadStore(getStoreUrl(null, true));

                                if (id === instanceManager.getStateFavoriteId()) {
                                    instanceManager.setState();
                                }
                            }, true, true);
                        });
                    }
                }
            }]
        }, {
            sortable: false,
            width: _FavoriteStyle2.default.paddingColWidth
        }],
        store: favoriteStore,
        listeners: {
            render: function render() {
                var size = Math.floor((uiManager.getHeight() - 330) / uiConfig.grid_row_height);
                this.store.pageSize = size;
                this.store.page = 1;
                this.store.loadStore();

                favoriteStore.on('load', function () {
                    if (this.isVisible()) {
                        this.fireEvent('afterrender');
                    }
                }, this);
            },
            afterrender: function afterrender() {
                var fn = function fn() {
                    var editArray = Ext.query('.tooltip-favorite-edit'),
                        sharingArray = Ext.query('.tooltip-favorite-sharing'),
                        deleteArray = Ext.query('.tooltip-favorite-delete'),
                        el;

                    for (var i = 0; i < editArray.length; i++) {
                        var el = editArray[i];
                        Ext.create('Ext.tip.ToolTip', {
                            target: el,
                            html: i18n.rename,
                            'anchor': 'bottom',
                            anchorOffset: -14,
                            showDelay: 1000
                        });
                    }

                    for (var i = 0; i < sharingArray.length; i++) {
                        el = sharingArray[i];
                        Ext.create('Ext.tip.ToolTip', {
                            target: el,
                            html: i18n.share_with_other_people,
                            'anchor': 'bottom',
                            anchorOffset: -14,
                            showDelay: 1000
                        });
                    }

                    for (var i = 0; i < deleteArray.length; i++) {
                        el = deleteArray[i];
                        Ext.create('Ext.tip.ToolTip', {
                            target: el,
                            html: i18n.delete_,
                            'anchor': 'bottom',
                            anchorOffset: -14,
                            showDelay: 1000
                        });
                    }
                };

                Ext.defer(fn, 100);
            },
            itemmouseenter: function itemmouseenter(grid, record, item) {
                this.currentItem = Ext.get(item);
                this.currentItem.removeCls('x-grid-row-over');
            },
            select: function select() {
                if (action === 'open') {
                    this.currentItem.removeCls('x-grid-row-selected');
                }
            },
            selectionchange: function selectionchange() {
                this.currentItem.removeCls('x-grid-row-focused');
            },
            itemdblclick: function itemdblclick() {
                if (action === 'saveas') {
                    saveButtonHandler();
                }
            }
        }
    });
    cmpToToggle.push(grid);

    titles = {
        open: i18n.open_favorite,
        saveas: i18n.save_favorite_as
    };

    windowItems = function () {
        var items = [];

        if (action === 'saveas') {
            items.push(nameTextField, descriptionTextField, showFavoritesLinkCt);
        }

        items.push(searchTextfield, filtersComboBox, gridHeaders, grid);

        return items;
    }();

    favoriteWindow = Ext.create('Ext.window.Window', {
        title: titles[action],
        bodyStyle: 'padding:1px; background-color:#fff',
        resizable: false,
        modal: true,
        width: _FavoriteStyle2.default.windowWidth,
        destroyOnBlur: true,
        items: windowItems,
        bbar: windowBbar,
        listeners: {
            show: function show(w) {
                var favoriteButton = uiManager.get('favoriteButton') || {};

                if (favoriteButton.rendered) {
                    uiManager.setAnchorPosition(w, favoriteButton);

                    if (!w.hasDestroyOnBlurHandler) {
                        uiManager.addDestroyOnBlurHandler(w);
                    }
                }

                (action === 'open' ? searchTextfield : nameTextField).focus(false, 500);

                if (action === 'saveas') {
                    showFavoritesLink.toggle();
                }
            },
            destroy: function destroy(w) {
                uiManager.unreg('favoriteWindow');
            }
        }
    });

    nameTextField.setEventKeyUpHandler(saveButtonHandler);
    // DHIS2-1147: enable Save button on name value change
    nameTextField.setEventChangeHandler(function () {
        saveButton.xable();
    });

    return favoriteWindow;
};
//# sourceMappingURL=FavoriteWindow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/FavoriteWindow.js
 ** module id = 33
 ** module chunks = 0 1
 **/